/**
 * @ignore
 * Created by daletan on 8/28/16.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');

// Components
const DetailsShipping = require('./DetailsShipping');
const DetailsReturns = require('./DetailsReturns');
const DetailsPaymentMethods = require('./DetailsPaymentMethods');
const DetailsInvoice = require('./DetailsInvoice');

const ShippingAndReturnsColumn = props => {
    const { hasUserId, item, user, quotes, context, userId, itemId, itemIsSold, itemIsUnlisted,
        dealerPk, viewer, favoriteDealer, favoriteDealerCta, dealerData, isPrintPage } = props;
    return (
        <div className="pdp-shipping-subcontainer">
            <div className="pdp-shipping-title-container">
                <h2 className="pdp-shipping-title header-primary-large pdp-secondary-header">Shipping & Returns</h2>
            </div>
            <div className="pdp-shipping-content-container">
                <DetailsShipping
                    context={context}
                    user={user}
                    quotes={quotes}
                    userId={userId}
                    itemIsSold={itemIsSold}
                    itemIsUnlisted={itemIsUnlisted}
                    itemId={itemId}
                    viewer={viewer}
                    dealerPk={dealerPk}
                    favoriteDealer={favoriteDealer}
                    favoriteDealerCta={favoriteDealerCta}
                    dealerData={dealerData}
                    item={item}
                />
                <DetailsReturns
                    context={context}
                    item={item}
                    user={user}
                />
                <DetailsPaymentMethods
                    item={item}
                    user={user}
                />
                <DetailsInvoice
                    context={context}
                    hasUserId={hasUserId}
                    itemId={itemId}
                    userId={userId}
                    viewer={viewer}
                    user={user}
                    isPrintPage={isPrintPage}
                />
            </div>
        </div>
    );
};

ShippingAndReturnsColumn.defaultProps = {
    isPrintPage: false
};

ShippingAndReturnsColumn.propTypes = {
    isPrintPage: PropTypes.bool,
    context: PropTypes.object,
    itemId: PropTypes.string,
    itemIsSold: PropTypes.bool,
    itemIsUnlisted: PropTypes.bool,
    hasUserId: PropTypes.bool,
    userId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    item: PropTypes.object,
    user: PropTypes.object,
    quotes: PropTypes.object.isRequired,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object
};

module.exports = Relay.createContainer(ShippingAndReturnsColumn, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null
    },
    fragments: {
        user: ({hasUserId, itemId, userId}) => Relay.QL`
            fragment on User {
                ${DetailsReturns.getFragment('user')}
                ${DetailsShipping.getFragment('user', {itemId, userId})}
                ${DetailsPaymentMethods.getFragment('user')}
                ${DetailsInvoice.getFragment('user', {hasUserId, itemId, userId})}
            }
        `,
        item: () => Relay.QL`
            fragment on Item {
                ${DetailsShipping.getFragment('item')}
                ${DetailsReturns.getFragment('item')}
                ${DetailsPaymentMethods.getFragment('item')}
            }
        `,
        viewer: ({hasUserId, itemId, userId}) => Relay.QL`
            fragment on Viewer {
                ${DetailsShipping.getFragment('viewer', {itemId, userId})}
                ${DetailsInvoice.getFragment('viewer', {hasUserId, itemId, userId})}
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ShippingAndReturnsColumn.jsx